import React from 'react';
import { HeadProps } from 'gatsby';

import SEO, { ISEO } from './SEO';

import { Normalize } from 'utils/types';

type CheckNormalizedConstraintExists<Model, Key extends keyof Model, Constraint> = Normalize<
  Model[Key]
> extends Constraint
  ? Pick<Model, Key>
  : never;

type AtLeastOneOfType<
  Model,
  Constraint,
  CollapsedUnion = {
    [Key in keyof Model]: CheckNormalizedConstraintExists<Model, Key, Constraint>;
  }
> = Partial<Model> & CollapsedUnion[keyof CollapsedUnion];

type KeyOfType<
  Model,
  Constraint,
  CollapsedUnion = {
    [Key in keyof Model]: CheckNormalizedConstraintExists<Model, Key, Constraint>;
  }
> = keyof CollapsedUnion[keyof CollapsedUnion];

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore -- Circular constraint
const withHead = <Query extends AtLeastOneOfType<Query, Queries.SEODataFragment>>(
  identifier: KeyOfType<Query, Queries.SEODataFragment>,
  options: Omit<ISEO, 'data'> = {}
): React.FC<
  HeadProps<{
    [key in KeyOfType<Query, Queries.SEODataFragment>]: Queries.SEODataFragment | null;
  }>
> =>
  function Head({ data }) {
    const queryData = data[identifier];
    if (!queryData) return null;

    return <SEO data={queryData.data} {...options} />;
  };

export default withHead;
